<template>
  <div :style="`background-image: url(${image});`" class="hero">
    <div class="container">
      <div class="row">

        <slot>
          <h1 class="col-lg-12 text-center text-white hero-title">
            با میکس ایت وب میلیونی شو
          </h1>
          <p class="col-lg-12 text-center text-white hero-desc">
            با طراحی یا فارسی سازی قالب و افزونه وردپرس و انتشار در راست چین،
            تا 500 میلیون تومان درآمد ماهانه رو تجربه کن !
          </p>

          <div class="img-section p-3 text-center">

            <img class="col-lg-8 mx-auto hero-img p-0 shadow"
                 src="https://api.mixitweb.com/storage/assets/2024-09-24 16_12_06-Window.png" alt=""/>
          </div>
        </slot>

      </div>
    </div>
  </div>

</template>


<script>
export default {
  name: "Section204",
  props: {
    image: {
      default: 'https://api.mixitweb.com/storage/assets/bggggggggg.png'
    }
  }
}
</script>

<style scoped>
.hero {

  background-size: cover;
  background-position: top;

  padding-top: 150px;
  position: relative;
}

.hero-title {
  font-size: 32px;
  color: #fff;
  font-weight: 600;
  text-shadow: 0 3px 18px rgba(35, 154, 25, 0.5);
}

.hero-desc {
  font-size: 18px;
  /* width: 348px; */
  color: #ffffff;
  font-weight: 400;
  line-height: 36px;
}

.hero-img {
  border-radius: 15px;
}


</style>